import { render, staticRenderFns } from "./video2Dialog.vue?vue&type=template&id=bb113af0&scoped=true"
import script from "./video2Dialog.vue?vue&type=script&lang=js"
export * from "./video2Dialog.vue?vue&type=script&lang=js"
import style0 from "./video2Dialog.vue?vue&type=style&index=0&id=bb113af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb113af0",
  null
  
)

export default component.exports